import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { selectMatchEvents, selectFilteredAndSortedMatchEvents } from 'features/match/matchSlice';
import {
  getConnectedAssistEvent,
  getConnectedFouledEvent,
  getConnectedOffenceEvent,
  getConnectedPenaltyGoalEvent,
  getConnectedPenaltyMissEvent,
  getConnectedPenaltySaveEvent,
  getConnectedPlayerOnEvent,
} from 'helpers/getConnectedEvent';

import Event from 'components/Event';

import StyledEventList from './StyledEventList';

const EventList: React.FC = () => {
  const matchEvents = useSelector(selectMatchEvents, shallowEqual);
  const filteredAndSortedMatchEvents = useSelector(selectFilteredAndSortedMatchEvents, shallowEqual);

  const eventElements = filteredAndSortedMatchEvents.map((matchEvent, index) => {
    const assistEvent = getConnectedAssistEvent(matchEvents, matchEvent);
    const substituteEvent = getConnectedPlayerOnEvent(matchEvents, matchEvent);
    const fouledEvent = getConnectedFouledEvent(matchEvents, matchEvent);
    const offenceEvent = getConnectedOffenceEvent(matchEvents, matchEvent);
    const penaltySaveEvent = getConnectedPenaltySaveEvent(matchEvents, matchEvent);
    const penaltyMissEvent = getConnectedPenaltyMissEvent(matchEvents, matchEvent);
    const penaltyGoalEvent = getConnectedPenaltyGoalEvent(matchEvents, matchEvent);

    return (
      <Event
        index={index}
        key={matchEvent.id || matchEvent.liveFeedSerialId}
        matchEvent={matchEvent}
        assistMatchEvent={assistEvent}
        substituteMatchEvent={substituteEvent}
        fouledMatchEvent={fouledEvent}
        offenceMatchEvent={offenceEvent}
        penaltySaveMatchEvent={penaltySaveEvent}
        penaltyMissMatchEvent={penaltyMissEvent}
        penaltyGoalMatchEvent={penaltyGoalEvent}
      />
    );
  });

  return <StyledEventList>{eventElements}</StyledEventList>;
};

export default EventList;
